import { useParams } from '@tanstack/react-router'

import { InvoiceServiceScreen } from '@/screens/InvoiceServiceScreen'
import { ServicePageShell } from '@/screens/ServicePageShell'
import { useJobInvoiceService } from '@/screens/useJobInvoiceService'

export function JobInvoicePrepScreenContainer() {
  const jobIdentity = useParams({ from: '/jobs/$id/invoice', select: (p) => p.id })
  const invoice = useJobInvoiceService(jobIdentity, () => {})

  if (invoice.kind === 'loading') {
    return <div className="bg-slate-50 text-slate-900"><main className="mx-auto max-w-4xl space-y-2 px-4 py-6"><h1 className="text-2xl font-semibold">Job Invoice Prep</h1><p className="text-sm text-slate-600">Loading job…</p></main></div>
  }
  if (invoice.kind === 'error') {
    return <div className="bg-slate-50 text-slate-900"><main className="mx-auto max-w-4xl space-y-2 px-4 py-6"><h1 className="text-2xl font-semibold">Job Invoice Prep</h1><p className="text-sm text-slate-600">Unable to load invoice data right now.</p></main></div>
  }
  if (invoice.kind === 'not_found') {
    return <div className="bg-slate-50 text-slate-900"><main className="mx-auto max-w-4xl space-y-2 px-4 py-6"><h1 className="text-2xl font-semibold">Job Invoice Prep</h1><p className="text-sm text-slate-600">Job not found. Check the link or return to the jobs list.</p></main></div>
  }

  const displayId = invoice.screenProps.publicId ?? jobIdentity

  return (
    <ServicePageShell
      serviceTypeLabel="Job"
      serviceId={displayId}
      customerName={invoice.screenProps.customerName}
      customerId={invoice.screenProps.customerId}
      customerPublicId={invoice.screenProps.customerPublicId}
      scheduledAtLabel={invoice.screenProps.scheduledAt}
      initialIssue={invoice.screenProps.issueSummary}
      activeTab="invoice"
      basePath="/jobs/$id"
      currentStatus={invoice.screenProps.calloutStatus}
      statusChanges={invoice.screenProps.statusChanges}
      getAuthorDisplayName={invoice.screenProps.getAuthorDisplayName}
    >
      <InvoiceServiceScreen {...invoice.screenProps} showHeader={false} />
    </ServicePageShell>
  )
}
